"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEME_TOGGLE_TO_LIGHT_COPY = exports.THEME_TOGGLE_TO_DARK_COPY = exports.THEME_APPLIES_EVERYWHERE_COPY = exports.THEME_SETUP_PROMPT_COPY = exports.THEME_DARK_COPY = exports.THEME_LIGHT_COPY = void 0;
exports.resolveTheme = resolveTheme;
exports.needsThemeBackfill = needsThemeBackfill;
exports.otherTheme = otherTheme;
const storedTheme_1 = require("./storedTheme");
function isThemePreference(value) {
    return value === "light" || value === "dark";
}
/**
 * Which theme to show: the account's value once the profile has loaded, otherwise the
 * device's stored choice (migrated by `resolveStoredTheme`), otherwise Light.
 */
function resolveTheme(server, stored, deviceIsDark) {
    if (isThemePreference(server))
        return server;
    return (0, storedTheme_1.resolveStoredTheme)(stored, deviceIsDark);
}
/**
 * True when the account has no theme yet, so the client should write up what this
 * device shows now. That's how existing users keep their theme on the day this ships.
 */
function needsThemeBackfill(server) {
    return !isThemePreference(server);
}
/** The other theme, for the dashboard header's one-tap switch. */
function otherTheme(theme) {
    return theme === "dark" ? "light" : "dark";
}
exports.THEME_LIGHT_COPY = "Light";
exports.THEME_DARK_COPY = "Dark";
/** The setup step's question, and the heading of the Appearance control. */
exports.THEME_SETUP_PROMPT_COPY = "Light or dark?";
/** Where the one setting applies, under every control that changes it. */
exports.THEME_APPLIES_EVERYWHERE_COPY = "Applies everywhere you sign in";
/** Accessible names of the dashboard header button, by the theme it switches TO. */
exports.THEME_TOGGLE_TO_DARK_COPY = "Switch to dark mode";
exports.THEME_TOGGLE_TO_LIGHT_COPY = "Switch to light mode";
//# sourceMappingURL=themePreference.js.map